import { useState, type FormEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { track } from '@/lib/analytics'

const NEWSLETTER_ENDPOINT =
  (import.meta.env.VITE_NEWSLETTER_WORKER_URL as string | undefined) ??
  'https://ode-newsletter.ryon-a0d.workers.dev/'

type Status = 'idle' | 'submitting' | 'success' | 'error'

export function NewsletterSignup() {
  const { t } = useTranslation()
  const [email, setEmail] = useState('')
  const [status, setStatus] = useState<Status>('idle')

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault()
    if (!email) return
    setStatus('submitting')
    try {
      const res = await fetch(NEWSLETTER_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      })
      setStatus(res.ok ? 'success' : 'error')
      track('newsletter_submitted', { ok: res.ok })
    } catch {
      setStatus('error')
    }
  }

  if (status === 'success') {
    return (
      <div className="p-4 rounded-lg text-lg">
        {t('newsIndex.subscribeSuccess')}
      </div>
    )
  }

  return (
    <form onSubmit={onSubmit} className="p-4 rounded-lg space-y-2">
      <div className="text-lg font-semibold">{t('newsIndex.subscribe')}</div>
      <input
        type="email"
        required
        autoComplete="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={t('newsIndex.subscribePlaceholder')}
        className="w-full px-3 py-2 rounded-md bg-transparent border border-mono-400 dark:border-mono-700 text-lg"
        aria-label={t('newsIndex.subscribe')}
      />
      <button
        type="submit"
        disabled={status === 'submitting'}
        className="w-full px-3 py-2 rounded-md text-base font-medium
          bg-mono-800 text-mono-100 dark:bg-mono-100 dark:text-mono-900 disabled:opacity-60"
      >
        {t('newsIndex.subscribeSubmit')}
      </button>
      {status === 'error' && (
        <div className="text-base text-red-500">{t('newsIndex.subscribeError')}</div>
      )}
    </form>
  )
}
